/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { compose } from 'redux';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderDetailsVolumeFieldPropTypes from './OrderDetailsVolumeField.component.props';
import orderDetailsVolumeFieldStyles from './OrderDetailsVolumeField.component.styles';

/**
 * OrderDetailsVolumeFieldComponent
 * @export
 * @class OrderDetailsVolumeFieldComponent
 * @extends {React.Component<OrderDetailsVolumeFieldComponentComposedProps, OrderDetailsVolumeFieldComponentState>}
 */
export class OrderDetailsVolumeFieldComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderDetailsVolumeFieldComponentProps>}
   * @memberof OrderDetailsVolumeFieldComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderDetailsVolumeField`}
   * @memberof OrderDetailsVolumeFieldComponent
   */
  static displayName = `OrderDetailsVolumeField`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderDetailsVolumeFieldComponent
   */
  static propTypes = OrderDetailsVolumeFieldPropTypes;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderDetailsVolumeFieldComponent />`
   * @memberof OrderDetailsVolumeFieldComponent
   */
  render() {
    const { InputProps, label, value } = this.props;
    const {
      classes: { root: inputRoot },
    } = InputProps;
    const { ordered, uom } = value;
    const unitOfMeasure = toDisplayUnit(uom);
    return (
      <Grid item key={label}>
        <I18n variant="caption">{label}</I18n>
        <div className={inputRoot}>
          <Typography>{`${ordered}${unitOfMeasure}`}</Typography>
        </div>
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<OrderDetailsVolumeFieldComponentProps>} */
const OrderDetailsVolumeField = compose(withStyles(themeCreateInjectableStyles(orderDetailsVolumeFieldStyles), { withTheme: true }))(
  OrderDetailsVolumeFieldComponent,
);

export default OrderDetailsVolumeField;
